import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { GlanceTile } from '../../../../../Common/GlanceTile/NewGlanceTile';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSubmissionPreferences } from '../../store/OrderPreference.selector';
import { extraxtTileArray } from './utils';

export const ExistingPlacementGlance = () => {
  const { t } = useTranslation();
  const {
    readyToSubmitPlacementIds,
    submissionLimits: { activePlacementCounts },
  } = useSelector(selectSubmissionPreferences);

  const [glanceTileArray, setGlanceTileArray] = useState(
    extraxtTileArray(t, activePlacementCounts, readyToSubmitPlacementIds),
  );

  useEffect(() => {
    setGlanceTileArray(extraxtTileArray(t, activePlacementCounts, readyToSubmitPlacementIds));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePlacementCounts, readyToSubmitPlacementIds]);

  return (
    <Grid container spacing={3}>
      {glanceTileArray.map(tile => (
        <Grid item>
          <GlanceTile {...tile} />
        </Grid>
      ))}
    </Grid>
  );
};
